const utils = require('frontend-controller/lib/utils')
const genericModalController = require('frontend-controller/lib/controllers/modals/generic')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'jobPrices',
        showHead: true,
        showIDs: true,
        showTDVerticalTop: true,
        isSortable: true,
        preventSortOfField: {
            price: true
        },
        rowActionsInline: true,
        rowActionsProperties: {
            colWidth: '40px',
        },
        rowActions: {
            edit: true,
            // customs: [
            //     // {
            //     //     buttonType: 'showLocation',
            //     // },
            //     {
            //         buttonType: 'delete',
            //         neutral: true,
            //     }
            // ]
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_prices': true,
        }
    },

    model: {
        resourceFilters: {
            order: [{
                fieldCode: 'validRange',
                direction: 'desc'
            }]
        }
    },

    methods: {
        onPrepareDone(){
            this.config.customHeadActionsFormMapping = {
                buttons: [
                    { buttonType: 'showInsert', context: this.config.buttonContext, positive: true, privilegeCode: 'bo_prices:create', }
                ]
            }

            if(!this.model.parentEntity){
                this.model.parentEntity = this.getResourceRegisterContent('parentEntity') || false
            }
            if(this.model.parentEntity){
                if(this.model.parentEntity.entityID && this.model.parentEntity.primaryKey === 'jobID'){
                    this.model.jobID = this.model.parentEntity.entityID
                    this.model.employeeID = this.model.parentEntity.employeeID
                    this.model.defaultPriceType = ((this.model.parentEntity.entityData || {}).attributes || {}).defaultPriceType || undefined
                }
            }
        },

        /**
         * this function is used to handle the different kinds of errors.
         * NOTE: if this function returns reject no error occurred (e.g., if the statusCode is 200)
         * NOTE: if this function resolves the given context is always the original context and NOT the error handling context.
         *
         * @param   context             {} - action perform context
         *          {
         *              component: ...
         *              [action]: ...
         *              error: {
         *                  statusCode: <statusCode>            mixed - status code || 'clientError'
         *                  name: <statusCode>                  string - error name
         *                  errorCode: <statusCode>             string - error code
         *                  message: <statusCode>               string - error message
         *                  details: <statusCode>               string - error details
         *                  [childErrors]: []                   [] - list of child errors
         *              },
         *              errorHandlingType: CONSTANTS.ERROR.HANDLING_TYPE[...]
         *                                      int - this error handling type defines the state of error handling
         *                                      e.g., has this error been thrown during error handling or has this error been thrown during custom error handling etc.
         *                                      NOTE: this flag will be filled by CONSTANTS.ERROR.HANDLING_TYPE
         *          }
         * @returns Promise
         */
        handleError: function(context){
            var baseError = utils.extractBaseError(context.error);

            if(
                baseError.statusCode == 409 &&
                baseError.errorCode == 'SEQUELIZE_EXCLUSION_CONSTRAINT_ERROR' &&
                baseError.table == 'bo_prices' &&
                (
                    baseError.column == 'unique_valid_jobID' ||
                    baseError.column == 'unique_valid_jobID_employeeID'
                )
            ){
                return this.performAction(
                    this.prepareAction('message', undefined, {
                        messageDisplay: {
                            message: `error:insertPrice.${baseError.column}`
                        }
                    }, {
                        rollbackContext: context,
                        statusControllerLoadingMessage: '',
                        statusControllerSavingMessage:  ''
                    })
                );
            }

            context.errorUnhandled = true;
            return utils.promise.resolve(context);
        },

        async getPriceConfigsForTimeRange(timeRange){
            const {
                from,
                to
            } = timeRange || {}

            try {
                const actionContext = await this.performAndStoreAction(
                    'getPriceConfigsForTimeRange_inEffect',
                    this.prepareAction('getPriceConfigsForTimeRange', undefined, {

                    }, {
                        source: {
                            load: {
                                resourceFilters: {
                                    from,
                                    to,
                                }
                            }
                        }
                    }),
                    true
                );
                return ((actionContext || {}).action || {}).response || { data: [] }

            } catch (error) {
                console.error(error)
            }
        },

        async getPricesForTimeRange(timeRange){
            const {
                from,
                to
            } = timeRange || {}

            try {
                const actionContext = await this.performAndStoreAction(
                    'getPricesForTimeRange_inEffect',
                    this.prepareAction('getPricesForTimeRange', undefined, {

                    }, {
                        source: {
                            load: {
                                resourceFilters: {
                                    from,
                                    to,
                                    jobID:      this.model.jobID,
                                    employeeID: this.model.employeeID,
                                }
                            }
                        }
                    }),
                    true
                );
                return ((actionContext || {}).action || {}).response || { data: [] }

            } catch (error) {
                console.error(error)
            }
        },

        async showInsert(buttonContext, buttonMode, options){
            options = options || {}
            const timeRange         = options.timeRange || {}
            const jobID             = this.model.jobID
            const employeeID        = this.model.employeeID
            const defaultPriceType  = this.model.defaultPriceType

            if(timeRange.code && timeRange.from && timeRange.to){
                if(jobID){
                    try {
                        const [
                            priceConfigs,
                            prices,
                        ] = await Promise.all([
                            this.getPriceConfigsForTimeRange(timeRange),
                            this.getPricesForTimeRange(timeRange),
                        ])

                        if(!utils.isEmpty(prices.data)){
                            const data = prices.data[0] || {}
                            const attributes = data.attributes || {}
                            const priceID = attributes[data.primaryKey || 'id']

                            if(priceID){
                                const decisionContext = await this.performDecision(
                                    'confirm',
                                    {
                                        component:  this,
                                        title:      storage.__('hint.priceAlreadyExistsForThisJobSwitchToEdit.title'),
                                        message:    storage.__('hint.priceAlreadyExistsForThisJobSwitchToEdit.message'),
                                    }
                                ) || {}
                                const decision = decisionContext.decision || {}
                                if(decision.type === 'yes'){
                                    this.showEdit(priceID, undefined, priceConfigs)
                                }
                            } else {
                                this.performAction(this.prepareAction('message', undefined, {
                                    messageDisplay: {
                                        title: 'hint.priceAlreadyExistsForThisJob.title',
                                        message: 'hint.priceAlreadyExistsForThisJob.message',
                                    }
                                }));
                            }
                        } else if(utils.isEmpty(priceConfigs.data)){
                            const decisionContext = await this.performDecision(
                                'confirm',
                                {
                                    component:  this,
                                    title:      storage.__('hint.addPricesAfterPriceConfigsOnly.title'),
                                    message:    storage.__('hint.addPricesAfterPriceConfigsOnly.message'),
                                }
                            ) || {}
                            const decision = decisionContext.decision || {}
                            if(decision.type === 'yes'){
                                await this.performAndStoreAction(
                                    'showInsert_priceConfigs_inEffect',
                                    this.prepareAction('showInsert_priceConfigs', undefined, {

                                    }, {
                                        source: {
                                            load: {
                                                componentData: {
                                                    actions: {
                                                        loadContent: {
                                                            source: {
                                                                load: {
                                                                    componentData: {
                                                                        model: {
                                                                            dirtyFields: {
                                                                                data: {
                                                                                    attributes: {
                                                                                        valid: timeRange,
                                                                                    },
                                                                                },
                                                                            },
                                                                        },
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    })
                                )
                            }
                        } else {
                            await this.performAndStoreAction(
                                'showInsert_prices_inEffect',
                                this.prepareAction('showInsert_prices', undefined, {
                                    priceConfigs,
                                }, {
                                    source: {
                                        load: {
                                            componentData: {
                                                actions: {
                                                    loadContent: {
                                                        source: {
                                                            load: {
                                                                componentData: {
                                                                    model: {
                                                                        dirtyFields: {
                                                                            data: {
                                                                                attributes: {
                                                                                    jobID,
                                                                                    employeeID,
                                                                                    type: defaultPriceType,
                                                                                    valid: timeRange,
                                                                                }
                                                                            }
                                                                        }
                                                                    },
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                })
                            )
                        }
                    } catch (error) {
                        console.error(error)
                    }

                } else {
                    return this.performAction(
                        this.prepareAction('message', undefined, {
                            messageDisplay: {
                                message:    'hint.addPricesAfterJobsOnly.message',
                            }
                        })
                    );
                }
            } else {
                return this.performAndStoreAction(
                    'showSelect_jobPrice_timeRange',
                    this.prepareAction(genericModalController.getAction({
                        component: [
                            '/',
                            'templates',
                            'core',
                            'modal',
                            'modal',
                        ],
                        config: {
                            // decisionComponentHandlesCancel: true,
                            decisionMaker: false,
                        },
                        model: {
                            titleKey: 'modal.showSelect_jobPrice_timeRange.title',
                            buttons: [
                                {
                                    mode: 'select',
                                    positive: true,
                                    buttonType: 'decisionComponent'
                                },
                                {
                                    buttonType: 'cancel',
                                    mode: 'abort'
                                }
                            ],
                        }
                    }, {
                        component: [
                            '/',
                            'templates',
                            'core',
                            'form',
                            'static',
                            'selectTimeRangeByCode',
                        ],
                        model: {
                            config: {
                                fields: {
                                    timeRange: {
                                        grantedFormat: {
                                            year:       true,
                                            quarter:    false,
                                            month:      false
                                        }
                                    }
                                }
                            }
                        }
                    }))
                )
            }
        },

        async showEdit(entityID, entityData, priceConfigs = {}){
            const baseActionKey = `showEdit_${this.config.buttonContext}`
            const actionKey = `${baseActionKey}_inEffect`

            if(utils.isEmpty((priceConfigs || {}).data)){
                const {
                    validFrom: from,
                    validTo: to,
                } = (entityData || {}).attributes || {}

                priceConfigs = await this.getPriceConfigsForTimeRange({
                    from,
                    to,
                })
            }

            if(utils.isEmpty((priceConfigs || {}).data)){
                return this.performMessage({
                    messageDisplay: {
                        message: 'error:prices.priceManagementWithoutPriceConfigImpossible'
                    }
                })
            }

            return this.performAndStoreAction(
                actionKey,
                this.prepareAction(baseActionKey, entityID, {
                    priceConfigs,
                }),
                true
            )
        },
    },

    hooks: {
        async onDecision($element, options){
            options = options || {}
            const decisionType = options.decisionType
            const decisionOptions = options.decisionOptions || {}
            const timeRange = decisionOptions.timeRange || {}

            if(decisionOptions.mode === 'select'){
                if(timeRange.code && timeRange.from && timeRange.to){
                    // close modal
                    if(options.decisionComponent && options.decisionComponent.hasClass('base_modal_modal')){
                        options.decisionComponent.hide()
                    }

                    this.showInsert(undefined, undefined, { timeRange })

                } else {
                    // TODO: warn user?
                }
            } else if(decisionType === 'submit'){
                const modal = options.decisionComponent || {}
                const form = ((((modal.actions || {}).loadContent || {}).source || {}).load || {}).component || {}
                if(modal.hasClass('base_modal_modal') && form.hasClass('base_form_form')){
                    try {
                        // prepare originalActionKey before modal.hide() when it is gone.
                        let originalParentActionKey = ''
                        modal.parent(parent => {
                            const parentAction = (parent.actions || {})[modal.parentActionKey || '~MISSING~ACTION~KEY~'] || {}
                            originalParentActionKey = parentAction.originalActionKey
                        })

                        // save form on submit
                        const responseContext = await form.submit() || {}

                        // hide modal after submit
                        await modal.hide()

                        // TODO: prevent flicker on hide vs submit

                        // open showInsert_price modal after showInsert_priceConfigs
                        if(originalParentActionKey === 'showInsert_priceConfigs'){
                            const attributes = ((responseContext.response || {}).data || {}).attributes || {}
                            const timeRange = {
                                code: attributes.validCode,
                                from: attributes.validFrom,
                                to: attributes.validTo,
                            }
                            await this.showInsert(undefined, undefined, { timeRange })
                        }
                    } catch(error){
                        console.error(error)
                    }
                }
            } else if(decisionType === 'cancel'){
                const modal = options.decisionComponent || {}
                if(modal.hasClass('base_modal_modal')){
                    await modal.hide()
                }
            }
        }
    }
}